import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';
import { Popconfirm, message } from 'antd';

import { bytesToString } from './helpers';
import { theme } from '../../../../styles';
import { SvgIcon } from '../../../svg-icon';
import { Tooltip } from '../../../popovers';
import { memoCallback } from '../../../../utils';
import {
  ItemWrap,
  ItemContentWrap,
  ExtensionIcon,
  ExtensionIconText,
  AttachmentMetaWrap,
  AttachmentNameWrap,
  AttachmentSizeWrap,
  TrashIconWrap,
  DeleteIcon,
  ItemContentContainer,
  FileIcon,
  FileIconText,
  AttachmentContainer,
  AttachmentName,
  ItemNinViewWrapper,
} from './styled-components';

const AttachmentItem = ({ attachment, onAttachmentRemove, minView }) => {
  const [stateLink, setLink] = useState('');
  const parentId = attachment.requestId || attachment.companyId;

  useEffect(() => {
    fetch(attachment.url)
      .then(response => response.blob())
      .then(blob => URL.createObjectURL(blob))
      .then(res => setLink(res))
      .catch(error => message.error(`error while fetching attachment: ${error}`, 500));
  }, [attachment.url]);

  return (
    <ItemWrap {...{ minView }}>
      {!minView &&
      <ItemContentWrap>
        <ExtensionIcon>
          <ExtensionIconText>
            .{attachment.extension}
          </ExtensionIconText>
        </ExtensionIcon>

        <AttachmentMetaWrap>
          <Tooltip
            title={attachment.name}
            placement="bottom"
          >
            <AttachmentNameWrap
              href={stateLink || attachment.url}
              download={attachment.name}
              target="__blank"
            >
              {attachment.name}
            </AttachmentNameWrap>
          </Tooltip>

          <AttachmentSizeWrap>
            {bytesToString(attachment.size)}
          </AttachmentSizeWrap>
        </AttachmentMetaWrap>
      </ItemContentWrap>}

      <ItemNinViewWrapper>
        {onAttachmentRemove && minView ? (
          <Popconfirm
            okType="danger"
            okText="Yes"
            cancelText="No"
            title="Are you sure delete this attachment?"
            onConfirm={() => onAttachmentRemove(
              parentId,
              attachment._id,
              attachment.name,
            )}
          >
            <DeleteIcon>
              <SvgIcon
                type="cancel"
                fillOpacity={0.8}
                color={theme.colors.vividRed}
                hoverColor={theme.colors.vividRed}
              />
            </DeleteIcon>
          </Popconfirm>
        ) : null}

        {minView &&
        <ItemContentContainer {...{ minView }}>
          <FileIcon>
            <FileIconText>
            .{attachment.extension}
            </FileIconText>
          </FileIcon>

          <AttachmentContainer>
            <Tooltip
              title={attachment.name}
              placement="bottom"
            >
              <AttachmentName
                target="__blank"
                download={attachment.name}
                href={stateLink || attachment.url}
              >
                {attachment.name}
              </AttachmentName>
            </Tooltip>

          </AttachmentContainer>
        </ItemContentContainer>}
      </ItemNinViewWrapper>

      {onAttachmentRemove && !minView ? (
        <Popconfirm
          okType="danger"
          okText="Yes"
          cancelText="No"
          title="Are you sure delete this attachment?"
          onConfirm={() => onAttachmentRemove(attachment._id)}
        >
          <TrashIconWrap data-popconfirm-stay-open>
            <SvgIcon type="trash" fillOpacity={0.8} />
          </TrashIconWrap>
        </Popconfirm>
      ) : null}
    </ItemWrap>
  );
};

AttachmentItem.propTypes = {
  attachment: object.isRequired,
  onAttachmentRemove: func,
  minView: bool,
};

AttachmentItem.defaultProps = {
  onAttachmentRemove: null,
  minView: false,
};

const shouldComponentUpdate = (prevProps, nextProps, omitItems = ['attachment']) =>
  memoCallback(prevProps, nextProps, omitItems);

export default React.memo(AttachmentItem, shouldComponentUpdate);



// WEBPACK FOOTER //
// ./src/components/attachments/list/item/index.js